import {getOffer} from "../../api/mainpage/offer";

const state = () => ({
  offer:{},
  newsId: null
})


const getters = {
  get_offer(state) {
    return state.offer;
  },
}

const mutations = {
  SET_OFFER(state,data){
    state.offer = data;}
}

const actions = {
  async fetchOffer({ commit }) {
    try {
      const response = await getOffer();
      commit('SET_OFFER', response.data.results);
    } catch (error) {
      // handle the error here
    }
  },

}




export  default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
